import { ProjectT } from './../../../models/models';
import dayjs from "dayjs";
import { CAMPAIGN_NAME_SEPARATOR, MEDIA_COMPANY_NONE_ID } from '../../../utils/constants';

export const mapCampaignDataForUpdate = (campaignData: any, defaultData: ProjectT) => {
    const campaignName = dayjs(campaignData.broadcastingDate).format('YYYY-MM') + ` ${CAMPAIGN_NAME_SEPARATOR} ` + campaignData.advertiser.shortName + (campaignData.brand.shortName !== campaignData.advertiser.shortName ? (` ${CAMPAIGN_NAME_SEPARATOR} ` + campaignData.brand.shortName) : '');
    // "No media company" (sentinel) persists as no FK (null); a real selection sends its client id.
    const mediaCompanyId = campaignData.mediaCompany?.value;
    const body = {
        "Name": `${campaignName}${campaignData.name ? ' — ' + campaignData.name : ''}`,
        "IndustryId": campaignData.marketCategory.value,
        "BroadcastingDate": campaignData.broadcastingDate,
        "BrandId": campaignData.brand.value,
        "AdvertiserId": campaignData.advertiser.value,
        "MediaCompanyId": mediaCompanyId === MEDIA_COMPANY_NONE_ID ? null : mediaCompanyId ?? null,
        // "ProjectComment": defaultData.ProjectComment,
        // "PostProductionCompanyId": campaignData.postProductionCompany.value,
        // "ProductionCompanyId": campaignData.productionCompany.value,
        // "ParticipantNames": campaignData.participantNames || 'NONE',
        // "SpeakerNames": campaignData.speakerNames || 'NONE',
        "AdvertisingAgencyId": campaignData.advertisingAgency.value,
        // "ProductionLocationIsrael": campaignData.productionLocationIsrael === 'local',
        // "Versions": defaultData.Versions,
        "Id": defaultData?.Id,
        "ProjectType": "VideoAd",
        // "Campaign": {
        //     "Id": defaultData?.Campaign?.Id,
        // },
        // "BroadcasterIds": defaultData.BroadcasterIds,
        // "broadcasters": defaultData.broadcasters || [],
        "addToExist": "0",
        "campaignRetry": false,
        "IsCampaignEdit": true,
    }
    
    return body;
};